import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import {
  AlertDialogComponent,
  AlertDialogData,
} from '../dialogs/alert-dialog/alert-dialog.component';
import { AuthService } from 'src/app/pages/core/abstraction/auth.service';
@Component({
  selector: 'app-fiat',
  templateUrl: './fiat.component.html',
  styleUrls: ['./fiat.component.scss'],
})
export class FiatComponent implements OnInit {
  @Input() type: number;
  @Input() showHeader = true;
  @Input() isDepositDisabled = false;
  @Input() monthLimit: number = 0;
  @Output() backEvent: EventEmitter<void> = new EventEmitter();
  txSelected: FormControl = new FormControl(0);
  showReminderMessage = false;
  showWarningMessage = true;

  constructor(public matDialog: MatDialog, public authService: AuthService) {}

  ngOnInit(): void {
    // MOSTRAR MENSAJE DE ALERTA APARTIR DE LAS 18 A 8
    const currentHour = new Date().getHours();
    if (currentHour >= 18 || currentHour < 8) {
      this.showReminderMessage = true;
    }
  }

  close() {
    this.matDialog.closeAll();
  }

  back() {
    this.backEvent.emit();
  }

  copyCBUToClipboard(type: string) {
    let value = '';
    if (type === 'ALIAS') {
      value = this.getAliasByType();
    } else if (type === 'CBU') {
      value = this.getCbuByType();
    }

    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.matDialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
      panelClass: 'modal-container',
      data: {
        title: `${type} copiado`,
        content: 'Transfiera el dinero desde tu Homebanking',
      },
    });
  }

  getCbuByType() {
    if(this.authService.loggedUser?.isArbitrator){
      if(this.type === 0) return '4310009942700000065019' 
      return '4310009943800000057377'
    }
    if (this.type === 0) {
      return '3220001812006856990024';
    } else {
      return '3220001805006856990013';
    }
  }

  getAliasByType() {
    if(this.authService.loggedUser?.isArbitrator){
      if(this.type === 0) return 'sixa.usd'
      return 'tiendacrypto.ars'
    }
    if (this.type === 0) {
      return 'CRYPTO.USD';
    } else {
      return 'CRYPTO.ARS';
    }
  }
}
